module.exports = __webpack_public_path__ + "static/media/home_2.e6800c96.jpg";